import propTypes from 'prop-types';

export const Badge = (props) => (
  <span className={`my-card__badge ${props.className || ''}`} style={props.style}>{props.children}</span>
);

Badge.propTypes = {
  className: propTypes.string,
  style: propTypes.object,
  children: propTypes.node.isRequired
};
